export default "__VITE_ASSET__CDG2T9GZ__"